import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { MiniProviderCardList } from '@kyruus/provider-components';
import { BREAKPOINTS } from '../../lib/constants';

export const AltProvidersHeader = styled.h2`
  color: ${fromTheme('color_text')};
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  margin: 0;
  margin-bottom: ${fromTheme('spacing_medium')};
`;

export const AltProvidersCards = styled(MiniProviderCardList)`
  > div {
    width: 100%;

    @media screen and (min-width: ${BREAKPOINTS.small}px) {
      width: calc(50% - 8px);
    }
  }
`;
